import type { IEsito} from "@/app/Comms";
import {Comms} from "@/app/Comms";
import {Model} from "@/app/Model";
import {Utils} from "@/app/Utils";
import {ItemResponsabilita} from "@/app/data/ResponsabilitaAdmin";
import {CommsResponsabilita} from "../CommsResponsabilita";

export class ResponsabilitaAdminComms {

    public commsResponsabilita: CommsResponsabilita | undefined = undefined;

    protected static instance: ResponsabilitaAdminComms;

    protected constructor() {
        //keep it protected to help with the singleton instance
    }

    public inChiamataResponsabilitaList: boolean = false;
    public inChiamataResponsabilitaSave: boolean = false;

    public static getInstance(): ResponsabilitaAdminComms {
        if (!ResponsabilitaAdminComms.instance) {
            ResponsabilitaAdminComms.instance = new ResponsabilitaAdminComms();
        }
        return ResponsabilitaAdminComms.instance;
    }

    public chiamataResponsabilitaList(callback: Function | null = null, soloPaginazione:boolean = false): void {
        if (this.commsResponsabilita) {
            if (Comms.hf_isNotLogged()) {
                if (this.commsResponsabilita.continueFunction) this.commsResponsabilita.continueFunction = this.chiamataResponsabilitaList;

                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);

                return;
            } else {
                this.commsResponsabilita.continueFunction = null;
            }

            let model: Model = Model.getReactiveInstance();

            if (!this.inChiamataResponsabilitaList) {
                this.inChiamataResponsabilitaList = true;

                model.res_admin.listaResponsabilita = [];

                let commander: string = "chiamataResponsabilitaList";
                let endpoint: string = "/graphql";
                let filters: string = '';
                let someFilters: string = '';

                //filtri da model.res_admin.filtriResponsabilita
                if (model.res_admin.filtriResponsabilita.id_doc_master != "") {
                    someFilters += ` { field: "id_doc_master", condition: "=", value: "${model.res_admin.filtriResponsabilita.id_doc_master}" }
                    `;
                }
                if (model.res_admin.filtriResponsabilita.tipologia_danno != "") {
                    someFilters += ` { field: "tipologia_danno", condition: "=", value: "${model.res_admin.filtriResponsabilita.tipologia_danno}" }
                    `;
                }
                if (model.res_admin.filtriResponsabilita.modifica_manuale != "") {
                    someFilters += ` { field: "modifica_manuale", condition: "=", value: "${model.res_admin.filtriResponsabilita.modifica_manuale}" }
                    `;
                }

                if (someFilters != '') {
                    filters = `where: {
                        must: [
                            ${someFilters}
                        ]
                    }`;
                }
                let payload = {
                    query: `{
                    msResponsabilitaQuery(
                        order: [{ field: "${model.res_admin.filtriResponsabilita.sort_field}", order: ${model.res_admin.filtriResponsabilita.sort_order} }]
                        ${filters}
                        select: ["*"]
                        paging: {offset: ${model.res_admin.paginazioneResponsabilita_start * model.res_admin.paginazioneResponsabilita_rows}, limit:${model.res_admin.paginazioneResponsabilita_rows}}
                    ) {
                        list
                        count
                        raw
                    }
                }`,
                    variables: {},
                    operationName: null,
                };

                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };

                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataResponsabilitaList = false;
                };

                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);

                    this.inChiamataResponsabilitaList = false;

                    if (esito.response && esito.response.data && esito.response.data.msResponsabilitaQuery && esito.response.data.msResponsabilitaQuery.list) {
                        esito.response.data.msResponsabilitaQuery.list.forEach((x: any) => model.res_admin.listaResponsabilita.push(this.prepareItemFromLoad(x)));

                        model.res_admin.paginazioneResponsabilita_tot = esito.response.data.msResponsabilitaQuery.count;
                        model.res_admin.paginazioneResponsabilita_pages = Math.ceil(model.res_admin.paginazioneResponsabilita_tot / model.res_admin.paginazioneResponsabilita_rows) -1;

                        if (model.res_admin.paginazioneResponsabilita_start > model.res_admin.paginazioneResponsabilita_pages) {
                            model.res_admin.paginazioneResponsabilita_start = model.res_admin.paginazioneResponsabilita_pages;
                        }

                        if (!soloPaginazione) {
                            model.res_admin.paginazioneResponsabilita_start = 0;
                        }
                    }

                    if (callback) callback(esito);
                };

                this.commsResponsabilita.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }

    public chiamataResponsabilitaSave(callback: Function | null = null): void {
        let model: Model = Model.getReactiveInstance();

        if (this.commsResponsabilita &&  model.res_admin.itemResponsabilita.id_doc_master != undefined && model.res_admin.itemResponsabilita.id_doc_master > 0) {
            if (Comms.hf_isNotLogged()) {
                if (this.commsResponsabilita.continueFunction) this.commsResponsabilita.continueFunction = this.chiamataResponsabilitaSave;

                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);

                return;
            } else {
                this.commsResponsabilita.continueFunction = null;
            }

            if (!this.inChiamataResponsabilitaSave) {
                this.inChiamataResponsabilitaSave = true;

                let commander: string = "chiamataResponsabilitaSave";
                let endpoint: string = "/graphql";
                let itemToSend : any = this.prepareItemForSave(model.res_admin.itemResponsabilita);

                let payload = {
                    query: `mutation {
                        msResponsabilitaUpdate(
                            input: ${JSON.stringify(itemToSend).replace(/"([^"]+)":/g, "$1:")}
                        )
                    }
                    `,
                    variables: {},
                    operationName: null,
                };

                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };

                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataResponsabilitaSave = false;
                };

                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);

                    this.inChiamataResponsabilitaSave = false;

                    if (esito.response && esito.response.data && esito.response.data.msResponsabilitaUpdate) {
                        model.res_admin.itemResponsabilita = this.prepareItemFromLoad(esito.response.data.msResponsabilitaUpdate);
                    }

                    CommsResponsabilita.getInstance().responsabilitaAdmin.chiamataResponsabilitaList((e: IEsito) => { }, false);

                    if (callback) callback(esito);
                };

                this.commsResponsabilita.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }

    public prepareItemForSave(item: ItemResponsabilita) : any {
        let clone: any = JSON.parse(JSON.stringify(item));
        delete clone.raw;
        return clone;
    }
    
    public prepareItemFromLoad(item: ItemResponsabilita) : any {
        let fieldsArrayToCheck: string[] = [
            "riferimento_normativo", "giudice"
        ]
        fieldsArrayToCheck.forEach((field: string): void => {
            //@ts-ignore
            if (item[field] == undefined || item[field] == null) { item[field] = []; }
        });
        let clone: any = JSON.parse(JSON.stringify(item));
        item.raw = clone;
        return item;
    }
}